import clsx from "clsx";
import React, { ReactNode } from "react";

export interface BrandLinkButtonProps {
  className?: string;
  icon?: ReactNode;
  children?: ReactNode;
  href: string;
}

export const BrandLinkButton: React.FC<BrandLinkButtonProps> = ({
  className,
  children,
  icon,
  href,
}) => {
  return (
    <a
      className={clsx(
        "inline-flex h-10 cursor-pointer items-center gap-2 px-3 py-2",
        className,
      )}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {icon}
      {children}
    </a>
  );
};
